// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__QYRSl","subheader":"ReorderModal_subheader__2WES4","listWrap":"ReorderModal_listWrap__2HwrX"};